import React, { useMemo } from "react";

import "./index.scss";

interface CustomTooltipProps {
  payload?: any[];
}

const CustomTooltip = ({ payload }: CustomTooltipProps) => {
  const label = useMemo(() => {
    const p = payload?.find(Boolean);
    if (!p) return "-";

    return p.payload.yValue;
  }, [payload]);

  return payload?.length ? (
    <div className="patient-chart-custom-tooltip">
      <div className="label-text">{label}</div>
      {payload.map((p) => (
        <div key={p.name} className="custom-content" style={{ color: p.color }}>
          {`${p.name} - ${p.payload.hasInsufficientData ? "Insufficient Data" : p.payload.xValue}`}
        </div>
      ))}
    </div>
  ) : null;
};

export default CustomTooltip;
